import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import {
  Button,
  Divider,
  Modal,
  Stack,
  TextInput,
  Text,
  Menu,
} from "@mantine/core";

import { Cubby } from "../../stores/Cubby";
import { MODALS } from "../../helpers/constants";
import {
  IconAt,
  IconBolt,
  IconFileInvoice,
  IconKey,
} from "@tabler/icons-react";
import { TextWithInfo } from "./textWithInfo";
import { TextWithInfoAndIcon } from "../dataDisplay/textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";

const ReceiveLightning = observer(({ cubby }: { cubby: Cubby }) => {
  return (
    <>
      <Modal
        opened={cubby.currentModal == MODALS.RECEIVE_LIGHTNING}
        onClose={() => cubby.setModal(null)}
        title={
          <TextWithInfoAndIcon
            text="Receive Lightning Payment"
            articleSlug={ARTICLES.RECEIVING_LIGHTNING_PAYMENTS.slug}
            icon={<IconBolt size={24} />}
            cubby={cubby}
            textSize="lg"
          />
        }
      >
        <Stack>
          <Button
            leftSection={<IconAt />}
            size="sm"
            variant="default"
            aria-label="keysend"
            onClick={() => cubby.setModal(MODALS.MANAGE_LIGHTNING_ADDRESS)}
          >
            Receive To Lightning Address
          </Button>
          <Text>
            Get a{" "}
            <Text span c="blue">
              @rizful.com
            </Text>{" "}
            lightning address. Provide this to others to receive multiple
            payments.
          </Text>
          <Divider my="xs" />
          <Button
            leftSection={<IconFileInvoice />}
            size="sm"
            variant="default"
            aria-label="make an invoice"
            onClick={() => cubby.setModal(MODALS.CREATE_INVOICE)}
          >
            Receive To Invoice
          </Button>

          <Text>
            Get a QR code or a text string. Provide this to others to receive a
            single payment.
          </Text>
        </Stack>
      </Modal>
    </>
  );
});

export default ReceiveLightning;
